/** Raster formats supported for profile photos and image attachments. */
export const STANDARD_IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "avif"];

const MIME_BY_EXT = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
  avif: "image/avif",
};

export const PROFILE_IMAGE_ACCEPT = [
  ...STANDARD_IMAGE_EXTENSIONS.map((ext) => `.${ext}`),
  ...Object.values(MIME_BY_EXT),
].join(",");

export const getFileExtension = (filename = "") => {
  if (!filename || typeof filename !== "string") return "";
  return filename.split(".").pop()?.toLowerCase() || "";
};

export const buildExtensionPattern = (extensions = STANDARD_IMAGE_EXTENSIONS) =>
  new RegExp(
    `(${extensions.map((ext) => `\\.${ext}`).join("|")})$`,
    "i"
  );

export const formatImageExtensionsLabel = (
  extensions = STANDARD_IMAGE_EXTENSIONS
) => [...new Set(extensions)].map((ext) => `.${ext}`).join(", ");
